module.exports = "/365FarmNet/dist/machineTable.6d7bfc8ac943757dd6679891a4f618e1.html";